import { fetchWrapper } from '../helpers';

export const requestService = {
  getReq,
  postReq
};

const baseUrlAPI = `${process.env.API_BASE_URL}`;

// API
function getReq(url) {
  return fetchWrapper.get(`${baseUrlAPI}${url}`);
}

function postReq(url, params) {
  return fetchWrapper.post(`${baseUrlAPI}${url}`, params);
}
